// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__Eut2p","ellipsis":"styles_ellipsis__qLNFX","text2AndMoreLines":"styles_text2AndMoreLines__ftoHX","tooltipTrigger":"styles_tooltipTrigger__9QC5c"};